export default "__VITE_ASSET__e28d3a0c__"